"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

const pixelId = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

// ✅ Helper: get a cookie by name
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// ✅ Helper: set the _fbc cookie from fbclid in URL
function captureFbc(searchParams: URLSearchParams) {
  const fbclid = searchParams.get("fbclid");
  if (fbclid) {
    const fbc = `fb.1.${Date.now()}.${fbclid}`;
    const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `_fbc=${fbc}; expires=${expires}; path=/; SameSite=Lax`;
  }
}

export default function FacebookPixel() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pixelId) return;
    if (typeof window === "undefined") return;

    const fbq = (window as unknown as { fbq?: (...args: unknown[]) => void }).fbq;
    if (!fbq) return;

    // ✅ Capture fbclid and store as _fbc cookie
    captureFbc(searchParams as unknown as URLSearchParams);

    // ✅ Track PageView with fbc and fbp
    const fbc = getCookie("_fbc");
    const fbp = getCookie("_fbp");

    fbq("track", "PageView", {}, {
      ...(fbc && { fbc }),
      ...(fbp && { fbp }),
    });

  }, [pathname, searchParams]);

  return null;
}
